(function () {
  if (window.__mrgOffreAtc) return;
  window.__mrgOffreAtc = true;

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-mrg-offre-atc]');
    if (!form) return;
    event.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var btn = form.querySelector('button');
    if (!idInput || !btn || btn.disabled) return;

    var variantId = Number(idInput.value);
    if (!variantId) return;

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        if (response.ok && typeof window.mrgNotifyUpcartAdd === 'function') {
          window.mrgNotifyUpcartAdd();
        }
      })
      .finally(function () {
        btn.disabled = false;
      });
  });
})();
